import { type TFunction } from 'i18next';

export const title = (t: TFunction, key: string) => t(`operations-economy-activity.title.${key}`);
export const label = (t: TFunction, key: string) => t(`operations-economy-activity.label.${key}`);

export const headers = (t: TFunction, key: string) =>
  t(`operations-economy-activity.header.${key}`);

export const buttons = (t: TFunction, key: string) =>
  t(`operations-economy-activity.button.${key}`);
export const validations = (t: TFunction, key: string) =>
  t(`operations-economy-activity.validations.${key}`);

export const messages = (t: TFunction, key: string) =>
  t(`operations-economy-activity.messages.${key}`);
